// src/utils/helpers.js

// ============================================
// FLAGS
// ============================================
export const getEmojiFlag = (countryCode) => {
  if (!countryCode) return "🇵🇱";
  return countryCode.toUpperCase().replace(/./g, char => 
    String.fromCodePoint(char.charCodeAt(0) + 127397)
  );
};

// ============================================
// VIDEO EMBED
// ============================================
export const getEmbedUrl = (url) => {
  if (!url) return null;
  
  // YouTube
  const ytMatch = url.match(/(?:youtu\.be\/|youtube\.com\/(?:.*v=|.*\/|.*embed\/|.*shorts\/))([^?&"'>]+)/);
  if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;
  
  // Facebook
  if (url.includes('facebook.com')) {
    return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=0`;
  }
  
  return null;
};

// ============================================
// DATE FORMATTERS
// ============================================
export const getRelativeTime = (timestamp) => {
  if (!timestamp) return "Data nieznana";
  const now = new Date();
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  const diffWeeks = Math.floor(diffDays / 7);
  
  if (diffMins < 1) return "teraz";
  if (diffMins < 60) return `${diffMins}m`;
  if (diffHours < 24) return `${diffHours}h`;
  if (diffDays < 7) return `${diffDays}d`;
  return `${diffWeeks}tyg`;
};

export const getFullDate = (timestamp) => {
  if (!timestamp) return "";
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  return date.toLocaleDateString('pl-PL', { 
    day: '2-digit', 
    month: 'short', 
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// ============================================
// NUMBER FORMATTERS (MARKETPLACE)
// ============================================
export const formatPrice = (price) => {
  if (!price && price !== 0) return "0 zł";
  return new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN',
    maximumFractionDigits: 0
  }).format(price);
};

export const formatMileage = (km) => {
  if (!km && km !== 0) return "0 km";
  return new Intl.NumberFormat('pl-PL').format(km) + ' km';
};
